module.exports = __webpack_public_path__ + "img/sen_self.7941e043.png";